
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useAnalytics } from "@/hooks/use-analytics";

interface ServicesHeaderProps {
  onAddService: () => void;
  onAddProduct: () => void;
}

export const ServicesHeader = ({ onAddService, onAddProduct }: ServicesHeaderProps) => {
  const { trackEvent } = useAnalytics();

  const handleAddService = () => {
    onAddService();
    trackEvent('open_service_form');
  };

  const handleAddProduct = () => {
    onAddProduct();
    trackEvent('open_product_form');
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <h2 className="text-2xl font-semibold">Mes services et produits</h2>
      <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">
        <Button onClick={handleAddService} className="w-full md:w-auto">
          <Plus className="mr-2 h-4 w-4" />
          Ajouter un service
        </Button>
        <Button onClick={handleAddProduct} className="w-full md:w-auto">
          <Plus className="mr-2 h-4 w-4" />
          Ajouter un produit
        </Button>
      </div>
    </div>
  );
};
